import { useEffect, useState } from "react";
import { ArrowClockwise } from "@phosphor-icons/react";
import { useRefresh } from "../contexts/RefreshContext";

function ago(ms) {
  const s = Math.max(0, Math.floor((Date.now() - ms) / 1000));
  if (s < 45) return "just now";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hr ago`;
  return `${Math.round(h / 24)} d ago`;
}

// "REFRESH DATA" control + a live "x min ago" chip. Sits in the page header (not the top bar) so it
// never gets mistaken for the SAP sync button. Reloads the current screen bypassing the server cache.
export function RefreshData() {
  const { refreshing, lastRefreshedAt, refreshNow } = useRefresh();
  const [, setNow] = useState(0);

  // re-render every 30s so the "x min ago" label stays current without any data fetch
  useEffect(() => {
    const id = setInterval(() => setNow((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="omh-refresh-data" data-testid="refresh-data">
      <span className="omh-refresh-chip" data-testid="refresh-data-age" title="When this screen's data was last loaded">
        {ago(lastRefreshedAt)}
      </span>
      <button
        type="button"
        className="omh-refresh-btn"
        onClick={refreshNow}
        disabled={refreshing}
        data-testid="refresh-data-btn"
        title="Reload the latest data for this screen (bypasses cache)"
      >
        <ArrowClockwise size={13} weight="bold" className={refreshing ? "spin" : undefined} />
        {refreshing ? "REFRESHING…" : "REFRESH DATA"}
      </button>
    </div>
  );
}
